import { InteractionLoader } from './interactionLoader';

export default class Header {
    constructor() {
        this.container = document.body
        this.actions()

        new InteractionLoader({
            'analytics': {
                'url': 'https://www.googletagmanager.com/gtag/js?id=G-YC7EQQK7GC',
                'onload': () => {
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = () => { dataLayer.push(arguments); }
                    gtag('js', new Date());
                    gtag('config', 'G-YC7EQQK7GC');
                    gtag('event', 'page_view', {
                        page_title: document.title,
                        page_location: document.location.href.split('.html')[0]
                    });
                }
            },
            'fonts': {
                'url': 'https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap',
                'type': 'font'
            }
        })

        // Pages that ship a canonical in their HTML (blog posts) keep it; a second one makes Google ignore both
        if (!document.querySelector('link[rel="canonical"]')) {
            let canonical = document.createElement('link')
            canonical.setAttribute('rel', 'canonical')
            canonical.setAttribute('href', document.location.href.split('.html')[0])
            document.head.appendChild(canonical)
        }
    }

    actions() {

    }
}